module.exports = __webpack_public_path__ + "img/authentication-bg.d3694463.jpg";